export default "__VITE_ASSET__B6gY2qCh__"